<!--
  Seit dem 21.08.2026 gibt es für Neukunden keine Abo-Tarife mehr
  (Basic/Standard/Premium eingestellt, Bestandskunden behalten ihre
  Konditionen im Portal). Technikhilfe hat EINEN Preis nach Aufwand — das
  frühere „Classic" — und braucht deshalb keine Tarifkarten mehr. Die
  Die Produkt-Preise der Safes stehen im Preis- und Leistungsverzeichnis
  (/entgelte) — bis 01.09.2026 lagen sie auf meinvertraut.de.
-->
<script lang="ts">
  import { geheZu, router } from '../router.svelte.ts';

  function zuRegistrierung(ereignis: MouseEvent): void {
    ereignis.preventDefault();
    if (router.pfad !== '/') geheZu('/');
    requestAnimationFrame(() =>
      document.getElementById('registrieren')?.scrollIntoView({ behavior: 'smooth', block: 'start' }),
    );
  }
</script>

<section id="preise" class="abschnitt hell">
  <div class="breite">
    <div class="mitte">
      <h2>Ein Preis. Kein Abo, keine Vertragsfallen.</h2>
      <p class="vorspann">
        Du zahlst nur, wenn du wirklich Hilfe brauchst — das Erstgespräch und die
        Problemanalyse sind immer kostenlos.
      </p>
    </div>

    <div class="preiszeile">
      <div class="preisblock">
        <div class="paket-preis">39&nbsp;€<span>pro halbe Stunde</span></div>
        <p class="leise">Remote-Hilfe — wir schauen gemeinsam auf deinen Bildschirm</p>
      </div>
      <div class="preisblock">
        <div class="paket-preis">49,50&nbsp;€<span>pro halbe Stunde</span></div>
        <p class="leise">Vor Ort in Bad Wurzach und Umgebung</p>
      </div>
    </div>

    <p class="mitte hinweis-abgrenzung">
      Bei den <a href="/#safes">Safes</a> sind
      Einrichtung, Einweisung und der Support für Passwort-Safe und Akten-Safe bereits im
      Paketpreis enthalten — allgemeine Technikhilfe darüber hinaus rechnen wir nach Aufwand zu den
      Preisen oben ab.
    </p>

    <p class="mitte hinweis-registrieren">
      Keine Mindestlaufzeit, kein Risiko.
      <a href="/#registrieren" onclick={zuRegistrierung}>Jetzt kostenlos registrieren →</a>
    </p>
  </div>
</section>

<style>
  .preiszeile {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 320px));
    justify-content: center;
    gap: 1.5rem;
    margin-top: 2rem;
  }

  .preisblock {
    text-align: center;
    background: #fff;
    border: 1px solid #e7edf3;
    border-radius: 16px;
    padding: 1.75rem 1.5rem;
  }

  .hinweis-abgrenzung {
    margin-top: 2rem;
    max-width: 46rem;
    margin-left: auto;
    margin-right: auto;
    color: var(--tb-text-600);
  }

  .hinweis-registrieren {
    margin-top: 1.25rem;
    color: var(--tb-text-600);
  }
</style>
